const webmUrl = new URL('../video/logo-loop.webm', import.meta.url).href;
const movUrl = new URL('../video/logo-loop.mov', import.meta.url).href;

export function initHeroLogo(): void {
    const host = document.querySelector<HTMLElement>('[data-swl-hero-logo]');

    if (host === null) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const mount = (): void => {
        const video = document.createElement('video');
        video.className = 'swl-hero-logo-video';
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'auto';

        for (const attr of ['muted', 'autoplay', 'playsinline', 'loop']) {
            video.setAttribute(attr, '');
        }

        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('disablepictureinpicture', '');

        const appleWebkit = navigator.vendor === 'Apple Computer, Inc.';
        const source = document.createElement('source');
        source.src = appleWebkit ? movUrl : webmUrl;
        source.type = appleWebkit ? 'video/quicktime' : 'video/webm';
        video.append(source);

        const reveal = (): void => {
            host.classList.add('is-animated');
        };

        const play = (): void => {
            Promise.resolve(video.play())
                .then(reveal)
                .catch(() => window.addEventListener('pointerdown', play, { once: true }));
        };

        video.addEventListener('canplay', play, { once: true });
        host.append(video);
    };

    const schedule = (): void => {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(mount, { timeout: 2500 });
        } else {
            window.setTimeout(mount, 700);
        }
    };

    if (document.readyState === 'complete') {
        schedule();
    } else {
        window.addEventListener('load', schedule, { once: true });
    }
}
